import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { alpha } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { PrimaryButton } from 'components/forms';
import type React from 'react';
import { NAVY, RADIUS_CARD, SURFACE_CONTAINER_LOW } from 'styles/tokens';

interface ConnectionGateProps {
  onSwitch: () => void;
  surface: 'ads' | 'pixel' | 'forms';
}

const COPY: Record<ConnectionGateProps['surface'], { eyebrow: string; title: string; body: string }> = {
  ads: {
    eyebrow: 'Cuentas',
    title: 'Conecta esta BU para sincronizar cuentas publicitarias.',
    body: 'Una vez conectada, podrás asignar las cuentas que descubra Meta a esta unidad de negocio.',
  },
  pixel: {
    eyebrow: 'Píxel & Eventos',
    title: 'Conecta esta BU para configurar píxel y eventos.',
    body: 'El píxel y el evento de conversión (BOFU) se configuran sobre las ad accounts ya asignadas.',
  },
  forms: {
    eyebrow: 'Formularios',
    title: 'Conecta esta BU para suscribir páginas de Facebook.',
    body: 'Al conectar Meta podrás suscribir páginas a Leadgen y empezar a recibir formularios en Relif.',
  },
};

const ConnectionGate: React.FC<ConnectionGateProps> = ({ onSwitch, surface }) => {
  const copy = COPY[surface];
  return (
    <Box
      sx={{
        backgroundColor: SURFACE_CONTAINER_LOW,
        borderRadius: RADIUS_CARD,
        py: { xs: 6, md: 10 },
        px: { xs: 3, md: 6 },
      }}
    >
      <Stack spacing={2} sx={{ alignItems: 'flex-start', maxWidth: 540 }}>
        <Typography
          sx={{
            fontFamily: 'Jost, sans-serif',
            fontSize: '0.6875rem',
            fontWeight: 600,
            letterSpacing: '0.12em',
            textTransform: 'uppercase',
            color: alpha(NAVY, 0.5),
          }}
        >
          {copy.eyebrow}
        </Typography>
        <Typography
          sx={{
            fontFamily: 'Jost, sans-serif',
            fontSize: { xs: '1.5rem', md: '2rem' },
            fontWeight: 700,
            letterSpacing: '-0.01em',
            color: NAVY,
            lineHeight: 1.15,
          }}
        >
          {copy.title}
        </Typography>
        <Typography sx={{ fontFamily: 'Jost, sans-serif', color: alpha(NAVY, 0.6), fontSize: '0.95rem' }}>
          {copy.body}
        </Typography>
        <PrimaryButton onClick={onSwitch}>Ir a Conexión</PrimaryButton>
      </Stack>
    </Box>
  );
};

export default ConnectionGate;
